import React from 'react';
import { Container } from '../../components/layouts/container';
import { Layout } from '../../components/layouts/layout';
import ProductCard from "../../components/ui/ProductCard";
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';


export const ProductPage: React.FC = () => {

  return (
    <Layout>
      <Container className="py-6">
        <div className="relative mx-auto grid h-full w-full grid-cols-1 items-start justify-center">
          <main className="flex-1 py-4 sm:py-6 md:py-8">
            <Link to="/dashboard" className='text-primary font-bold flex items-center justify-centergap-2 hover:underline'>
              <ChevronLeft size={20} />
              Retour
            </Link>
            <ProductCard />
          </main>
        </div>
      </Container>
    </Layout>
  );
};

